import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import './PinGate.css';

export default function PinGate({ type, children }) {
  const navigate = useNavigate();
  const storageKey = `pin-auth-${type}`;
  const [authorized, setAuthorized] = useState(false);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const saved = sessionStorage.getItem(storageKey);
    if (saved === 'true') setAuthorized(true);
  }, [storageKey]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setChecking(true);
    try {
      const result = await api.verifyPin(pin, type);
      if (result.valid) {
        sessionStorage.setItem(storageKey, 'true');
        if (result.token) {
          sessionStorage.setItem('auth-token', result.token);
        }
        setAuthorized(true);
      }
    } catch (err) {
      setError('Invalid PIN. Please try again.');
      setPin('');
    } finally {
      setChecking(false);
    }
  }

  if (authorized) return children;

  return (
    <div className="pin-gate">
      <div className="pin-gate-card card">
        <div className="pin-gate-icon">&#128274;</div>
        <h2 className="pin-gate-title">
          {type === 'cafe' ? 'Cafe Access'
            : type === 'kitchen' ? 'Kitchen Access'
            : type === 'counter' ? 'Counter POS'
            : 'Admin Access'}
        </h2>
        <p className="pin-gate-desc">Enter the PIN to continue</p>
        <form onSubmit={handleSubmit} className="pin-gate-form">
          <input
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={8}
            placeholder="Enter PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
            autoFocus
            className="pin-gate-input"
          />
          {error && <p className="error-text">{error}</p>}
          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={pin.length < 4 || checking}
          >
            {checking ? 'Checking...' : 'Enter'}
          </button>
        </form>
        {type !== 'counter' && (
          <button
            type="button"
            className="pin-gate-back"
            onClick={() => navigate('/staff')}
          >
            ← Back to staff access
          </button>
        )}
      </div>
    </div>
  );
}
